export default __webpack_public_path__ + "static/media/5175.d87dbc0c.png";